/**
 * Demo analyses and demo institution (`app/services/admin/demo_admin_service.py`).
 *
 * Split out of `brainfocus_api.ts` (FE Arch 1.0, #1165), which re-exports everything
 * here through the `BrainFocusApi` facade. Requests go through `client.request` so tests
 * can stub it on the module namespace.
 */
import * as client from '@brainfocus/web/api/client';
import { assertPojo } from '@brainfocus/web/api/response';

// ========== Demo Management API (SuperAdmin only) ==========

/**
 * Toggle demo flag on an analysis (SuperAdmin only)
 */
export async function toggleDemoAnalysis(recordingId: number): Promise<{ success: boolean; demo: boolean }> {
    const response = await client.request('POST', '/admin/toggle-demo-analysis', {
        recording_id: recordingId,
    });
    assertPojo<{ success: boolean; demo: boolean }>(response);
    return response as { success: boolean; demo: boolean };
}

/**
 * Get demo settings (SuperAdmin only)
 */
export async function getDemoSettings(): Promise<DemoSettings> {
    const response = await client.request('POST', '/admin/get-demo-settings', {});
    assertPojo<DemoSettings>(response);
    return response as DemoSettings;
}

/**
 * Set the demo institution (SuperAdmin only)
 */
export async function setDemoInstitution(institutionId: number): Promise<void> {
    await client.request('POST', '/admin/set-demo-institution', {
        institution_id: institutionId,
    });
}

/**
 * Demo settings (SuperAdmin only)
 */
export interface DemoSettings {
    demoInstitutionId: number | null;
}
